module.exports = __webpack_public_path__ + "img/login.f564d915.svg";